import React from 'react';

export const Brand = ({ testId = 'brand-logo' }) => (
  <img className="brand-logo" src="/images/fatt-logo.png" width="500" height="200"
    alt="FATT Elevadores" data-testid={testId} />
);